export default "__VITE_ASSET__l7cxpPGK__"